import { aggregateEvents } from '@onward-delivery/core';

export const getWarehouseEstimates = (order) => {
    const events = aggregateEvents(order?.wh_events || []);
    return {
        est_ship_date: order?.warehouse_estimated_ship_date || events.est_ship_date || null,
        est_received_date: order?.warehouse_estimated_delivery_date || events.est_received_date || null,
    };
};

const sameWarehouseEstimate = (next, prev) => (next || null) === (prev || null);

export const withWarehouseEstimateEvent = (order, previous) => {
    const { warehouse_estimated_delivery_date, warehouse_estimated_ship_date, ...rest } = order;
    const row = {
        ...rest,
        ...(warehouse_estimated_delivery_date ? { warehouse_estimated_delivery_date } : {}),
        ...(warehouse_estimated_ship_date ? { warehouse_estimated_ship_date } : {}),
    };
    const changed =
        !sameWarehouseEstimate(warehouse_estimated_ship_date, previous?.warehouse_estimated_ship_date) ||
        !sameWarehouseEstimate(warehouse_estimated_delivery_date, previous?.warehouse_estimated_delivery_date);

    if (!changed) {
        return row;
    }

    return {
        ...row,
        wh_events: {
            data: [
                {
                    action: 'START:AWAITING',
                    est_received_date: warehouse_estimated_delivery_date,
                    est_ship_date: warehouse_estimated_ship_date,
                },
            ],
        },
    };
};

export const warehouseEstimateOrderFields = ({ est_ship_date, est_received_date } = {}) => ({
    ...(est_ship_date ? { warehouse_estimated_ship_date: est_ship_date } : {}),
    ...(est_received_date ? { warehouse_estimated_delivery_date: est_received_date } : {}),
});

export const findMatchingWarehouseEvent = (events, { eventId, action, transitionNext }) => {
    if (eventId) {
        return (events || []).find((event) => event.event_id === eventId) || {};
    }
    if (action) {
        return (events || []).findLast((event) => event.action === action) || {};
    }
    if (transitionNext) {
        return (events || []).findLast((event) => event.transition?.next === transitionNext) || {};
    }
    return {};
};

export const getWarehouseEventUpsertColumns = (prev, previous, target, { timestampAttr, params }) => {
    const derivedCols = Object.keys(prev).filter((col) => prev[col] !== previous[col]);
    return [...new Set([...derivedCols, timestampAttr, ...Object.keys(params || {}), 'status'])].filter(
        (col) => !['action', 'event_id', 'order_id'].includes(col) && target[col] !== undefined
    );
};

export const toWarehouseEventInput = (event) => {
    const { __typename, state, transition, driver, wh_driver, location, ...remaining } = event;
    return remaining;
};
